let COLORS = {
  DASH_BG: "#E9ECEC",
  PRIMARY: "#4C5BF8",
  PRIMARY_GRAD: "linear-gradient(270deg, #4C5BF8 0%, #746DF2 100%)",
  LOGIN_BG_GRAD:
    "linear-gradient(-45deg,rgb(42, 0, 179) 0%,rgb(97, 108, 255) 100%)",
  GREEN_TRUCK_GRAD: "linear-gradient(97deg, #59B97B 1.76%, #175 98.24%)",
  TRACKING_GREEN: "#25AB6C",
  INDIAN_FLAG_GRAD:
    "linear-gradient(129deg, rgba(205,90,32,1) 0%, rgba(255,255,255,1) 47%, rgba(232,244,243,1) 53%, rgba(50,155,147,1) 100%)",
};

export default COLORS;
